import { Translation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import BasicModal from '@app/components/Modal/BasicModal';
import documentAuthService from '@app/libs/auth/documentAuthService';
import { getExitRoute } from '@app/store/contract-setup/selectors';
import { modalClose } from '@app/store/modal/actions';

export default function EditorExitToMyDocumentsModal() {
  const dispatch = useDispatch();

  const history = useHistory();
  const isLinkUser = documentAuthService.isLinkUser();

  const location = useLocation<{ exitPath?: string } | undefined>();
  const exitRoute = useSelector(getExitRoute);

  const handleModalClose = () => {
    dispatch(modalClose());
  };

  const handleExit = () => {
    if (location.state?.exitPath) {
      history.push(location.state.exitPath);
    } else if (isLinkUser) {
      /**
       * 서명 진행에서 링크 유저 나가기 버튼을 처리하기위한 코드입니다.
       * 링크 유저는 내 문서 메뉴로 이동할 수 없어서 '뒤로가기' 처리합니다.
       */
      history.goBack();
    } else {
      history.push(exitRoute);
    }

    dispatch(modalClose());
  };

  return (
    <Translation>
      {(t) => (
        <BasicModal
          cancelText={t('Global-cancel')}
          closeText={t('Global-exit')}
          content={t('EditorExitToMyDocumentsModal-content')}
          title={t('Global-exit')}
          onCancel={handleModalClose}
          onClose={handleExit}
        />
      )}
    </Translation>
  );
}
